import createRouter from "./createRouter";
import LayoutContainer from "@/views/Layout/LayoutContainer.vue";

export const routes = [
  {
    path: '/mobile',
    redirect: '/mobile/workbench',
    component: LayoutContainer,
    children: [
      {
        path: 'workbench',
        name: 'MobileWorkbench',
        component: () => import('@/views/Mobile/MobileWorkbench.vue'),
        meta: {
          title: '工作台'
        }
      },
      {
        path: 'apps',
        name: 'MobileApps',
        component: () => import('@/views/Mobile/MobileApps.vue'),
        meta: {
          title: '应用中心'
        }
      },
      {
        path: 'contacts',
        name: 'MobileContacts',
        component: () => import('@/views/Mobile/MobileContacts.vue'),
        meta: {
          title: '通讯录'
        }
      }
    ]
  }
]

export default createRouter(routes)